import Vue from "vue";
import Vuex from "vuex";
import {
  addScheduleInterview,
  getScheduledInterview,
  editScheduleInterview,
} from "../../utils/apiFunctions.js";
Vue.use(Vuex);

//state
const state = () => ({
  interviewDetails: [],
  // scheduledInterviewID : "",
  editInterviewData: {},
  interviewProcessData: {},
  feedbackFormData: {},
});

// getters
const getters = {
  getSingleSchedulesData: (state) => state.editInterviewData,
  getInterviewProcess: (state) => state.interviewProcessData,
  getFeedbackForm: (state) => state.feedbackFormData,
};

//action
const actions = {
  // POST SCHEDULE INTERVIEW API
  async saveScheduleInterview(state, payload) {
    let data = await payload;
    addScheduleInterview(data)
      .then((res) => {
        if (res.status == 200) {
          state.commit("saveInterview", data);
        }
      })
      .catch((err) => {
        let data = {};
        state.commit("saveInterview", data);
        throw err;
      });
  },

  // GET SCHEDULED INTERVIEW
  async getScheduledInterview(state, data) {
    await getScheduledInterview(data)
      .then((res) => {
        if (res.status == 200) {
          let payload = res.data.data;
          state.commit("saveInterviewDetails", payload);
        }
      })
      .catch((err) => {
        throw err;
      });
  },

  async editScheduledInterview(state, payload) {
    let data = await payload;
    editScheduleInterview(data)
      .then((res) => {
        if (res.status == 200) return res;
        else state.commit("editInterviewScheduled", data);
      })
      .catch((err) => {
        throw err;
      });
  },
};

// mutations
const mutations = {
  // SCHEDULE INTERVIEW
  saveInterview(state, payload) {
    state.interviewDetails.unshift(payload);
  },

  // GET INTERVIEW DETAILS
  async saveInterviewDetails(state, payload) {
    const data = await payload;
    state.editInterviewData = data;
  },

  // EDIT INTERVIEW
  editInterviewScheduled(state, payload) {
    for (let i in state.editInterviewData) {
      if (state.editInterviewData[i].interviewID === payload.interviewID) {
        // Copying the OBJECT
        state.editInterviewData[i] = { ...payload };
      }
    }
  },

  saveInterviewProcess(state, payload) {
    state.interviewProcessData = payload;
  },

  saveFeedbackForm(state, payload) {
    state.feedbackFormData = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
